<template>
    <div class="title">
        提醒您
    </div>
    <div class="content xs:max-w-[24rem]">
        <ol :class="{'list-inside list-decimal':result.isBothShow}">
            <li
                v-for="item in result.data"
                v-show="item.verifyResult === false"
                :key="item.id"
                :class="{'indent-1':result.isBothShow}"
            >
                本次{{ item.mobileChange ? '變更後' : '留存於本公司' }}之行動電話
                <span class="text-lg text-black font-bold pr-1">
                    {{ item.mobile }}
                </span>
                經核實後非{{ item.id === 'applicant' ? '要保人' : '' }}{{ item.id === 'insured' ? '被保險人' : '' }}本人所申辦
            </li>
        </ol>
        <div class="mt-1.5">
            請再次確認門號是否正確？
            <br>
            若確認留存非本人申辦之門號，請點選『說明關係及原因』。
        </div>
    </div>
    <div class="action justify-center">
        <button
            class="btn btn-accent rounded-full text-sm xs:text-base mr-1 xs:mr-3.5"
            @click.stop="$emit('goTelChange')"
        >
            修改行動電話
        </button>
        <button
            class="btn btn-accent rounded-full text-sm xs:text-base"
            @click.stop="$emit('goRelationship')"
        >
            說明關係及原因
        </button>
    </div>
</template>

<script>
export default {
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    emits: ['goTelChange', 'goRelationship'],
};
</script>
